// Fixed social-platform list for navbar `socialLinks` cards — deliberately
// NOT the generic icon picker (see the wrong-airplane-emoji mistake this
// replaces): each platform has one correct, unambiguous real brand icon
// baked in, so an admin can never pick a mismatched icon for Facebook et al.
// Stable platform-id strings (not icon names) are stored in config, same
// asset-id-style indirection as every other picker in this system — each
// client repo maps the same id to its OWN icon library (react-icons/fa,
// lucide-react) via SOCIAL_PLATFORM_ID → component, with a safe generic
// fallback (e.g. a link icon) for any unrecognized id.
import { FacebookOutlined, InstagramOutlined, TelegramFilled, WhatsAppOutlined } from "@ant-design/icons";

export const SOCIAL_PLATFORM_OPTIONS = [
    { value: "facebook",  label: "Facebook" },
    { value: "instagram", label: "Instagram" },
    { value: "telegram",  label: "Telegram" },
    { value: "whatsapp",  label: "WhatsApp" },
];

// Name → component lookup for this dashboard's own preview rendering.
export const SOCIAL_PLATFORM_ICONS = {
    facebook:  FacebookOutlined,
    instagram: InstagramOutlined,
    telegram:  TelegramFilled,
    whatsapp:  WhatsAppOutlined,
};

// Resolves a stored platform id to its icon component, or `null` if
// unrecognized (e.g. a stale/never-picked value) — callers render their own
// fallback, never crash on an unrecognized id.
export function resolveSocialPlatformIcon(platform) {
    return SOCIAL_PLATFORM_ICONS[platform] || null;
}
